export const salesQuoteHandler = {
    pathPattern: '/brands/:brandId/sales',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/sales` }),
    meta: {
        title: 'Sales quote',
        description: 'Opens the sales / quote surface in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: { params: { brandId: 'BXqExampleBrandId' } },
    },
};
//# sourceMappingURL=sales-quote.js.map